export interface ProvidedMatchCount {
	E: number;
	L: number;
	O: number; //Outright
	T: number;
	WO: number; //means 'Starting Soon' (only used in CV)
}

export type MarketType = 'L' | 'U' | 'T' | 'E' | 'O';

export type ProvidedMarket = keyof ProvidedMatchCount;
export type PartialRecord<K extends keyof never, T> = {
	[P in K]?: T;
};

export const galaxyMarketMenuPriorityMapping: PartialRecord<MarketType, ProvidedMarket> = {
	'T': 'T',
	'E': 'E',
	'L': 'L',
	'U': 'WO',
	'O': 'O'
};

export const marsMarketMenuPriorityMapping: PartialRecord<MarketType, ProvidedMarket> = {
	'L': 'L',
	'U': 'WO',
	'T': 'T',
	'E': 'E',
	'O': 'O'
};

export const marsParlayMarketMenuPriorityMapping: PartialRecord<MarketType, ProvidedMarket> = {
	'L': 'L',
	'T': 'T',
	'E': 'E',
	'O': 'O'
};

export type RawMarketData = ProvidedMatchCount & {
	Days: Day;
	Group?: Group;
}

export type Day = {
	[key: string]: number;
}

export type Group = {
	[key: string]: RawMarketData;
}

export const menuDefinition = {
	M0: 'sports',
	M1: 'olympics',
	M2: 'world-cup',
	M3: 'euro-cup',
	M4: 'winter-olympics',
	M49: 'nba',
	M8: 'asia-games',
	M5: 'copa-america',
	M9: 'asian-cup',
	M22: 'nations-league',
	M34: 'club-world-cup',
	M6: 'womens-world-cup',
	M11: 'fiba-world-cup',
	M19: 'eurobasket',
	M25: 'asia-cup',
	M38: 'wimbledon',
	M37: 'us-open',
	M35: 'australian-open',
	M36: 'roland-garros',
	M42: 'bwf-world-championships',
	M43: 'badminton-thomas-uber-cup',
	M45: 'indian-premier-league',
	M46: 'icc-t20-world-cup',
	M47: 'icc-world-cup',
	M40: 'fivb-world-championship',
	M14: 'sea-games',
	M21: 'commonwealth-games',
	M13: 'youth-olympics-games',
	M23: 'aff-cup',
	M7: 'womens-euro',
	M10: 'womens-asian-cup',
	M24: 'womens-aff-cup',
	M15: 'ameri-cup',
	M20: 'afrobasket',
	M12: 'womens-fiba-world-cup',
	M16: 'womens-eurobasket',
	M26: 'womens-asia-cup',
	M17: 'womens-americup',
	M18: 'womens-afrobasket',
	M41: 'badminton-asia-championship',
	M44: 'bwf-world-tour-finals',
	M48: 'icc-champions-trophy',
	M39: 'fivb-nations-league',
	M29: 'virtual-epl',
	M30: 'virtual-la-liga',
	M31: 'virtual-serie-a',
	M32: 'virtual-bundesliga',
	M33: 'virtual-ligue-1',
	M50: 'saba-virtual-fifa-world-cup',
	M51: 'fun88-virtual-fifa-world-cup',
	M52: 'm88-virtual-fifa-world-cup',
	M27: 'virtual-euro',
	M28: 'virtual-copa',
} as const;
export type MenuDefinitionEnum = typeof menuDefinition[keyof typeof menuDefinition];
export type EventMode = keyof typeof menuDefinition;
export type EventName = (typeof menuDefinition)[keyof typeof menuDefinition];
export type RawMenuData = Record<EventMode, RawMarketData> & {
	GameId: number;
	Name: string;
};